import { render, staticRenderFns } from "./CatapultBannerProductCard.vue?vue&type=template&id=50970f58&scoped=true"
import script from "./CatapultBannerProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatapultBannerProductCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatapultBannerProductCard.vue?vue&type=style&index=0&id=50970f58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50970f58",
  null
  
)

export default component.exports